<template>
    <div class="sketch-breadcrumb" :class="totalLicenses">
        <span>{{ pageName }}</span>
        <div v-if="tutorial && !tutorialLicenses" class="video-tutorial" @click="openVideoTutorial()">
            <div class="play-icon">
                <b-icon-play-fill></b-icon-play-fill>
            </div>
            <div class="play-button">
                Vezi tutorial utilizare
            </div>
        </div>
        <div v-else-if="tutorial && tutorialLicenses && $route.fullPath.includes('comanda-licenta')" style="display: flex; align-items: center;">
            <div class="video-tutorial" @click="openLicenseTutorial('pf')">
                <div class="play-icon">
                    <b-icon-play-fill></b-icon-play-fill>
                </div>
                <div class="play-button">
                    Vezi tutorial o licență
                </div>
            </div>
            <div class="video-tutorial" @click="openLicenseTutorial('consultant')">
                <div class="play-icon">
                    <b-icon-play-fill></b-icon-play-fill>
                </div>
                <div class="play-button">
                    Vezi tutorial mai multe licențe
                </div>
            </div>
        </div>
        <VideoTutorialPopup
            :schimbaModal="modalShow"
            @hideTempModal="modalShow = false"
        >
        </VideoTutorialPopup>
    </div>
</template>

<script>
    import {BIconPlayFill} from 'bootstrap-vue';
    import VideoTutorialPopup from '@/pages/Aplicatii/M3/M3Sketch/components/VideoTutorialPopup'
    import api from '@/helpers/api'
    import axios from '@/helpers/axios'
    export default {
        components: {
            BIconPlayFill,
            VideoTutorialPopup
        },
        props: {
            pageName: {
                type: String,
                default: '',
            },
            tutorial: {
                type: Boolean,
                default: false,
            },
            tutorialLicenses: {
                type: Boolean,
                default: false,
            },
            tutorialName: {
                type: String,
                default: '',
            },
            tutorialActive: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                modalShow: false,
                totalLicenses: 0
            }
        },
        mounted() {
        },
        methods: {
            openVideoTutorial() {
                this.$emit('startTutorial')
            },
            openLicenseTutorial(type) {
                this.$emit('startTutorial', type)
            },
            getLicenseData() {
                axios.get(api.API_ENDPOINTS.m3Licenses)
                    .then( response => {
                        console.log('response.data', response.data);
                        this.totalLicenses = (Number(response.data.m3_licenses_available) + Number(response.data.m3_licenses_used));
                    })
            }
        }
    }
</script>

<style scoped>
.sketch-breadcrumb{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.video-tutorial{
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-right: 25px;
}
.play-icon, .play-button{
    background-color: #49cda8;
}
.play-icon{
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 5px;
}
.play-button{
    padding: 1px 20px;
}
</style>